import { useQueries } from '@tanstack/react-query';
import { getIntervalFromDateRange } from 'pages/admin/CostDashboard/helper';
import { IUseGetCostSummary } from 'pages/admin/CostDashboard/hooks/useGetCostSummary';
import useGetRollupNamespaces from 'pages/admin/CostDashboard/hooks/useGetRollupNamespaces';
import { bff } from 'shared/api';
import { CostSummaryV2Reply } from 'shared/types/protoc-gen/bffbillsystem';
import { QUERY_KEYS } from 'shared/types/react-query';

interface IUseGetAllCostSummaries extends IUseGetCostSummary {
  namespaceType: string;
}

const useGetAllCostSummaries = (params: IUseGetAllCostSummaries) => {
  const { data: namespaceList, isLoading: isNamespaceLoading } = useGetRollupNamespaces({
    type: params.namespaceType,
  });

  const queries = useQueries({
    queries:
      namespaceList?.namespace.map(namespace => ({
        queryKey: [
          QUERY_KEYS.ADMIN_COST_SUMMARIES,
          params.startDate,
          params.endDate,
          namespace,
          params.kind,
          params.type,
          params.namespaceType,
        ],
        queryFn: async (): Promise<CostSummaryV2Reply> => {
          const kind = params.kind !== 'ALL' ? params.kind : '';
          const type = params.type !== 'ALL' ? params.type : '';

          const payload = {
            ...params,
            period: getIntervalFromDateRange(params.startDate, params.endDate),
            namespace,
            kind,
            type,
          };

          const res = await bff.get('/bff/cost/summary_v2', {
            params: payload,
          });

          return res.data;
        },
        enabled: !!namespace,
      })) || [],
  });

  const isLoading = isNamespaceLoading || queries.some(q => q.isLoading);
  const isError = queries.some(q => q.isError);
  const isSuccess = queries.every(q => q.isSuccess);

  const data =
    namespaceList?.namespace.map((ns, i) => ({
      namespace: ns,
      data: queries[i]?.data,
    })) || [];

  return {
    data,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetAllCostSummaries;
